<div class="modal-header">
	<h5 class="modal-title m-auto text-dark fw-semibold">{{ title }}</h5>
	<button
		(click)="cancel()"
		type="button"
		class="btn-close close pull-right ms-0"
		aria-label="Close"
	>
		<span aria-hidden="true" class="visually-hidden">&times;</span>
	</button>
</div>
<div class="modal-body text-center">
	<img
		src="assets/icons/modal/warning.svg"
		alt="Logo warning alterações não salvas"
		class="atlas-spacing-my-3"
	/>

	<p class="text-muted">{{ description }}</p>
</div>
<div class="modal-footer">
	<button (click)="cancel()" type="button" class="btn btn-secondary">
		{{ btnSecondaryLabel }}
	</button>
	<button (click)="confirm()" type="button" class="btn btn-danger">
		{{ btnDangerLabel }}
	</button>
</div>
